var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column flex-grow-1 align-items-center justify-content-center full-height",
    },
    [
      _c("img", {
        staticClass: "cms-login-form__logo",
        attrs: { src: _vm.$getSetting("assets.logo"), alt: "" },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "ak-panel ak-panel--no-padding cms-login-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.nextStep.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "ak-panel__body" },
            [
              _c("ak-loader", {
                attrs: { loading: _vm.loading, lightOverlay: true },
              }),
              _vm._v(" "),
              _c("h1", { staticClass: "text--center" }, [
                _vm._v(_vm._s(_vm.$t("Aanmelden"))),
              ]),
              _vm._v(" "),
              _vm.ssoFailed
                ? _c("div", { staticClass: "ak-form__error m-b-xs-10" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "Aanmelden mislukt. Contacteer je IT verantwoordelijke of gebruik je e-mailadres."
                          )
                        ) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.storageWarning && _vm.step === "email"
                ? _c("div", { staticClass: "ak-form__error m-b-xs-10" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.storageWarning) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition-group",
                {
                  staticClass: "cms-login-form__main",
                  attrs: { name: "slide-left" },
                  on: { "after-enter": _vm.focusField },
                },
                [
                  _vm.step === "email"
                    ? _c(
                        "div",
                        { key: "email", staticClass: "cms-login-form__step" },
                        [
                          _vm.showAccountChooser
                            ? _c(
                                "div",
                                { staticClass: "warehouse-login-accounts" },
                                [
                                  _vm._l(_vm.savedAccounts, function (account) {
                                    return _c(
                                      "div",
                                      {
                                        key: account.email,
                                        staticClass:
                                          "warehouse-login-accounts__account",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "warehouse-login-accounts__identity",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loginSavedAccount(
                                                  account
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "warehouse-login-accounts__name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(account.displayName)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "warehouse-login-accounts__email",
                                              },
                                              [_vm._v(_vm._s(account.email))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "warehouse-login-accounts__remove",
                                            attrs: {
                                              type: "button",
                                              "aria-label": _vm.$t(
                                                "Verwijderen van dit toestel"
                                              ),
                                              title: _vm.$t(
                                                "Verwijderen van dit toestel"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeSavedAccount(
                                                  account
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "ak-icon" },
                                              [_vm._v("delete")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "warehouse-login-accounts__actions",
                                    },
                                    [
                                      _c(
                                        "ak-link",
                                        {
                                          attrs: { disableBackground: true },
                                          on: { click: _vm.useAnotherAccount },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Aanmelden met een ander account"
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : [
                                _c("ak-input-text", {
                                  ref: "email",
                                  attrs: {
                                    id: "email",
                                    type: "email",
                                    hasError: _vm.errorMessage !== null,
                                    error: _vm.errorMessage,
                                    title: _vm.$t("E-mailadres"),
                                  },
                                  model: {
                                    value: _vm.values.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.values, "email", $$v)
                                    },
                                    expression: "values.email",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ak-button-group" },
                                  [
                                    _c(
                                      "ak-button",
                                      {
                                        attrs: { "full-width": true },
                                        on: { click: _vm.nextStep },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("Ga verder")) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.savedAccounts.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "warehouse-login-accounts__actions",
                                      },
                                      [
                                        _c(
                                          "ak-link",
                                          {
                                            attrs: { disableBackground: true },
                                            on: {
                                              click: _vm.showSavedAccounts,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Terug naar opgeslagen accounts"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === "password"
                    ? _c(
                        "div",
                        {
                          key: "password",
                          staticClass: "cms-login-form__step",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "cms-login-form__email" },
                            [
                              _c(
                                "ak-button",
                                {
                                  attrs: {
                                    disableBackground: true,
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToStep("email")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "ak-icon ak-button__icon" },
                                    [_vm._v("account_circle")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.values.email) + " "),
                                  _c("i", { staticClass: "ak-icon m-l-5" }, [
                                    _vm._v("expand_more"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("ak-input-password", {
                            ref: "password",
                            attrs: {
                              id: "password",
                              hasError: _vm.errorMessage !== null,
                              error: _vm.errorMessage,
                              title: _vm.$t("Wachtwoord"),
                            },
                            model: {
                              value: _vm.values.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.values, "password", $$v)
                              },
                              expression: "values.password",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ak-button-group" },
                            [
                              _c(
                                "ak-button",
                                {
                                  attrs: { "full-width": true },
                                  on: { click: _vm.nextStep },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("Ga verder")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === "tfa"
                    ? _c(
                        "div",
                        { key: "tfa", staticClass: "cms-login-form__step" },
                        [
                          _c(
                            "div",
                            { staticClass: "cms-login-form__email" },
                            [
                              _c(
                                "ak-button",
                                {
                                  attrs: {
                                    disableBackground: true,
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToStep("email")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "ak-icon ak-button__icon" },
                                    [_vm._v("account_circle")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.values.email) + " "),
                                  _c("i", { staticClass: "ak-icon m-l-5" }, [
                                    _vm._v("expand_more"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("ak-input-text", {
                            ref: "tfa",
                            attrs: {
                              id: "tfa",
                              hasError: _vm.errorMessage !== null,
                              error: _vm.errorMessage,
                              title: _vm.$t("Verificatie in 2 stappen"),
                              helpText: _vm.$t(
                                "Een verificatiecode van de <b>Google Authenticator-app</b> ontvangen"
                              ),
                            },
                            model: {
                              value: _vm.values.authenticationCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.values, "authenticationCode", $$v)
                              },
                              expression: "values.authenticationCode",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ak-button-group" },
                            [
                              _c(
                                "ak-button",
                                {
                                  attrs: { "full-width": true },
                                  on: { click: _vm.nextStep },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("Ga verder")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.sso && _vm.sso.enabled
                ? _c("div", { staticClass: "cms-login-form__sso-group" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Of ga verder met:")) +
                        "\n                "
                    ),
                    _c(
                      "div",
                      { staticClass: "ak-button-group" },
                      _vm._l(_vm.sso.services, function (service) {
                        return _c(
                          "ak-button",
                          {
                            key: service.id,
                            style: { "--button-background": service.color },
                            attrs: {
                              title: service.description,
                              icon: service.icon,
                              href: service.href,
                              outlined: true,
                              "full-width": true,
                              size: "small",
                            },
                          },
                          [
                            service.logo
                              ? _c("img", {
                                  staticClass: "ak-button__img",
                                  attrs: {
                                    src: service.logo,
                                    alt: service.description,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(service.description) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cms-login-form__bottom" },
            [
              _c(
                "ak-link",
                {
                  attrs: { disableBackground: true },
                  on: { click: _vm.passwordRecovery },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("Wachtwoord vergeten?")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }